module.exports = __webpack_public_path__ + "img/132.7d5e32fd.jpg";